import { Typography } from '@mui/material';
import type {
  BackupJob,
  InventoryResource,
  RestoreJob,
  ScanJob,
} from '@repo/api-gw-sdk';

import { CloudProviderIndicator } from '../cloudProviderIndicator';
import { isJob, isRestoreJob } from '../queryBuilder/properties';

export const CloudAccountCell = (
  entity: InventoryResource | BackupJob | RestoreJob | ScanJob
) => {
  const providerAccountId = isJob(entity)
    ? isRestoreJob(entity)
      ? entity.destinationDetails.providerAccountId
      : entity.resourceDetails?.providerAccountId
    : entity.providerAccountId;

  const cloudProvider = isJob(entity)
    ? isRestoreJob(entity)
      ? entity.destinationDetails.cloudProvider
      : entity.resourceDetails?.cloudProvider
    : entity.cloudProvider;

  return (
    providerAccountId &&
    (cloudProvider ? (
      <CloudProviderIndicator
        cloudProvider={cloudProvider}
        text={providerAccountId}
      />
    ) : (
      <Typography>{providerAccountId}</Typography>
    ))
  );
};
